module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Abbreviations"
    }
  }, [_c('p', {
    staticClass: "fm_headts",
    attrs: {
      "id": "loabb"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xv",
      "title": "xv"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#loa"
    }
  }, [_vm._v("ABBREVIATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("AAN—Archiwum Akt Nowych, Archives of New Records")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("AIPN—Archiwum Instytut Pamięci Narodowej, Archive of the Institute of National Remembrance")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("AK—Armia Krajow, Home Army")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("AL—Armia Ludowa, People’s Army")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("CKŻP—Centralny Komitet Żydów w Polsce, the Central Committee of Jews in Poland")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("CPSSM—Commission for the Protection of Sites of Suffering and Martyrdom")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("FRG—Federal Republic of Germany")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("GDR—German Democratic Republic")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("JAC—Jewish Antifascist Committee")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("JDC—American Joint Distribution Committee")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("KPP—Komunistyczna Partia Polski, Communist Party of Poland")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("ORT—Organization for Rehabilitation through Training")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("PAP—Polish News Agency")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("PeKaO—Polska Kasa Opieki, Polish Aid Bank")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("PRL—Polska Rzeczpospolita Ludowa, People’s Republic of Poland")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("PUWP—The Polish United Workers’ Party, Polska Zjednoczona Partia Robotnicza")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("PWN—Państwowe Wydawnictwo Naukowe, National Scientific Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("TASS—Telegraph Agency of the Soviet Union")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("TSKŻ—Towarzystwo Społeczno-Kulturalne Żydów w Polsce, Social Cultural Association of Jews in Poland")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "title": "xvi"
    }
  }, [_vm._v("WZO—World Zionist Organization")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("ZBoWiD—Związek Bojowników o Wolność i Demokrację, Society of Fighters for Freedom and Democracy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("ZRWM—Związek Religijny Wyznania Mojżeszowego, Religious Union of the Jewish Faith")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_paratsa"
  }, [_vm._v("ŻTK—Żydowskie Towarzystwo Kultury w Polsce, Jewish Cultural Society")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47236855","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Abbreviations.vue
// module id = 78
// module chunks = 0